import { H1, H2, H3 } from "../Headers/Headings";
import { IconButton } from "../Button/Button";
import { useState } from "react";
import { Help } from "../Icons";
import { InfoMessage } from "../InfoMessage/InfoMessage";
import { Expandable } from "../Expandable/Expandable";
import styles from "./HeadingWithInfo.module.css";
import AlignedContent from "../AlignedContent";
import { useTranslations } from "../../contexts/Translation";

const getHeadingComponent = (level: number) => {
  if (level === 1) return H1;
  if (level === 2) return H2;
  return H3;
};

const HeadingWithInfo = ({
  className,
  heading,
  level = 3,
  info,
}: { className?: string; heading: string; level?: number; info: React.ReactNode | string }) => {
  const t = useTranslations("misc");
  const [isOpen, setIsOpen] = useState(false);
  const HeadingComponent = getHeadingComponent(level);

  return (
    <div className={styles.container}>
      <HeadingComponent className={className}>
        <AlignedContent>
          {heading}
          <IconButton active={isOpen} onClick={() => setIsOpen(!isOpen)} title={t("moreInfo")} variant='info'>
            <Help />
          </IconButton>
        </AlignedContent>
      </HeadingComponent>
      <Expandable isOpen={isOpen}>
        <InfoMessage className={styles.infoMessage} type='info'>
          {info}
        </InfoMessage>
      </Expandable>
    </div>
  );
};

export default HeadingWithInfo;
